export interface DebugItem {
  code: string;
  description: string;
  id: string;
  inputErrorMessage?: string;
  inputPlaceholder?: string;
  title: string;
}

export type DebugInfo = DebugItem[];

export const validateDebugInfo = (data: unknown): DebugInfo => {
  if (!Array.isArray(data)) {
    console.warn('Debug info is not an array, returning empty array');
    return [];
  }

  const validatedDebugInfo: DebugInfo = [];

  for (const item of data) {
    if (!item || typeof item !== 'object') {
      console.warn(
        'Invalid debug item (null/undefined or not object), skipping',
      );
      continue;
    }

    const debugItem = item as Record<string, unknown>;

    // Required Fields
    if (
      typeof debugItem.code !== 'string' ||
      typeof debugItem.description !== 'string' ||
      typeof debugItem.id !== 'string' ||
      typeof debugItem.title !== 'string'
    ) {
      console.warn(
        `Invalid debug item missing required fields (id: ${debugItem.id || 'unknown'}), skipping`,
      );
      continue;
    }

    const validatedItem: DebugItem = {
      code: debugItem.code,
      description: debugItem.description,
      id: debugItem.id,
      title: debugItem.title,
    };

    // Optional Fields
    if (debugItem.inputErrorMessage !== undefined) {
      if (typeof debugItem.inputErrorMessage === 'string') {
        validatedItem.inputErrorMessage = debugItem.inputErrorMessage;
      } else {
        console.warn(
          `Invalid inputErrorMessage type for debug item ${debugItem.id}, skipping this field`,
        );
      }
    }

    if (debugItem.inputPlaceholder !== undefined) {
      if (typeof debugItem.inputPlaceholder === 'string') {
        validatedItem.inputPlaceholder = debugItem.inputPlaceholder;
      } else {
        console.warn(
          `Invalid inputPlaceholder type for debug item ${debugItem.id}, skipping this field`,
        );
      }
    }

    validatedDebugInfo.push(validatedItem);
  }

  return validatedDebugInfo;
};
